
// import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

// import Home from "./pages/Home";
// import LotteryRegistration from "./pages/LotteryRegistration";
// import UserDashboard from "./pages/UserDashboard";
// import ShopNow from "./pages/ShopNow";
// import Legal from "./pages/Legal";

// import Navbar from "./components/Navbar";
// import Footer from "./components/Footer";

// import AdminLogin from "./admin/AdminLogin";
// import AdminDashboard from "./admin/AdminDashboard";
// import AdminProtectedRoute from "./admin/AdminProtectedRoute";
// import AdminLayout from "./admin/AdminLayout";
// import AdminSidebar from "./admin/AdminSidebar";
// import { Outlet } from "react-router-dom";
// import Gallery from "./pages/Gallery";
// import AdminGallery from "./admin/AdminGallery";
// import Terms from "./pages/Terms";
// import ContactSection from "./pages/ContactSection";

// import GiverLogin from "./pages/GiverLogin";
// import GiverDashboard from "./pages/GiverDashboard";
// import GiverProtectedRoute from "./pages/GiverProtectedRoute";
// import BusinessPlan from "./pages/BusinessPlan";
// import Award from "./pages/Award";


// export default function App() {
//   return (
//     <BrowserRouter>
//       <Navbar />

//       <div className="min-h-[80vh]">
//         <Routes>

//           {/* User Routes */}
//           <Route path="/" element={<Home />} />
//           {/* <Route path="/lottery" element={<LotteryRegistration />} /> */
//           <Route path="/register" element={<LotteryRegistration />} />}
//           <Route path="/register/:ref" element={<LotteryRegistration />} />

//           <Route path="/award" element={<Award />} />

//           <Route path="/shop" element={<ShopNow />} />
//           <Route path="/gallary" element={<Gallery />} />

//           <Route path="/legal" element={<Legal />} />
//           <Route path="/terms" element={<Terms />} />
//            <Route path="/contact" element={<ContactSection />} />
//           <Route path="/businessplan" element={ <BusinessPlan/> } />



//           {/* <Route path="/dashboard" element={<UserDashboard />} /> */}

// {/* Giver System */}
// <Route path="/giver-login" element={<GiverLogin />} />

// <Route
//   path="/dashboard"
//   element={
//     <GiverProtectedRoute>
//       <GiverDashboard />
//     </GiverProtectedRoute>
//   }
// />


//           {/* Admin Login */}
//           <Route path="/admin-login" element={<AdminLogin />} />

//           {/* Full Admin System with Sidebar */}
//           <Route
//             path="/admin"
//             element={
//               <AdminProtectedRoute>
//                 <AdminLayout>
//                   <AdminSidebar />
//                   <div className="ml-52 w-full">
//                     <Outlet />
//                   </div>
//                 </AdminLayout>
//               </AdminProtectedRoute>
//             }
//           >
//             <Route index element={<h2 className="p-4">Welcome MeruRam Admin Side Page </h2>} />
//             <Route path="coupons" element={<AdminDashboard />} />
//             <Route path="gallery" element={<AdminGallery />} />
//           </Route>

//         </Routes>
//       </div>

//       <Footer />
//     </BrowserRouter>
//   );
// }



import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";

// User Pages
import Home from "./pages/Home";
import LotteryRegistration from "./pages/LotteryRegistration";
import ShopNow from "./pages/ShopNow";
import Legal from "./pages/Legal";
import Terms from "./pages/Terms";
import ContactSection from "./pages/ContactSection";
import BusinessPlan from "./pages/BusinessPlan";
import Award from "./pages/Award";
import Gallery from "./pages/Gallery";
// import AdminGallery from "./admin/AdminGallery";

// Admin Pages
import AdminLogin from "./pages2/AdminLogin";
import AdminDashboard from "./pages2/AdminDashboard";

// Super Admin Pages
import SuperAdminLogin from "./pages2/SuperAdminLogin";
import SuperAdminDashboard from "./pages2/SuperAdminDashboard";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Protected Route Wrappers
function SuperAdminRoute({ children }) {
  const { admin } = useAuth();
  if (!admin || admin.role !== "superadmin") {
    return <Navigate to="/superadmin/login" replace />;
  }
  return children;
}

function AdminRoute({ children }) {
  const { admin } = useAuth();
  if (!admin || admin.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Navbar />

        <div className="min-h-[80vh]">
          <Routes>
            {/* User Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<LotteryRegistration />} />
            <Route path="/register/:ref" element={<LotteryRegistration />} />
            <Route path="/award" element={<Award />} />
            <Route path="/shop" element={<ShopNow />} />
            <Route path="/gallary" element={<Gallery />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<ContactSection />} />
            <Route path="/businessplan" element={<BusinessPlan />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />

            {/* Super Admin Routes */}
            <Route path="/superadmin/login" element={<SuperAdminLogin />} />
            <Route
              path="/super-admin"
              element={
                <SuperAdminRoute>
                  <SuperAdminDashboard />
                </SuperAdminRoute>
              }
            />

            {/* Catch All */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>

        <Footer />
      </BrowserRouter>
    </AuthProvider>
  );
}